import { FormControl, FormLabel, Grid } from "@mui/material";
import type { FC } from "react";
import { AssociatedFilesEdit } from "../../components/associatedFiles/AssociatedFilesEdit";
import { AssociatedFilesView } from "../../components/associatedFiles/AssociatedFilesView";
import { useProviderFiles } from "./useProviderFiles";

interface Props {
  readonly providerId: string;
  readonly files: { readonly name: string; readonly url: string }[];
  readonly listTemplate: { readonly name: string; readonly url: string } | undefined;
  readonly readOnly?: boolean;
}

const ProviderFiles: FC<Props> = ({ providerId, files, listTemplate, readOnly }) => {
  const { addAttachment, deleteAttachment, addListTemplate, deleteListTemplate } = useProviderFiles(providerId);

  if (readOnly) {
    return (
      <>
        <Grid size={12}>
          <FormControl>
            <FormLabel>Powiązane pliki</FormLabel>
            <AssociatedFilesView values={files ?? []} />
          </FormControl>
        </Grid>
        {listTemplate && (
          <Grid size={12}>
            <FormControl>
              <FormLabel>Wzór listy</FormLabel>
              <AssociatedFilesView values={[listTemplate]} />
            </FormControl>
          </Grid>
        )}
      </>
    );
  }

  return (
    <>
      <Grid size={12}>
        <FormControl>
          <FormLabel>Powiązane pliki</FormLabel>
          <AssociatedFilesEdit
            values={files ?? []}
            onNewFile={async (v) => {
              await addAttachment(v);
            }}
            onRemoveFile={async (idx) => {
              const attachment = files[idx];
              await deleteAttachment(attachment.name);
            }}
          />
        </FormControl>
      </Grid>
      <Grid size={12}>
        <FormControl>
          <FormLabel>Wzór listy</FormLabel>
          <AssociatedFilesEdit
            values={listTemplate ? [listTemplate] : []}
            maxFiles={1}
            hideFilename
            addButtonTooltip="Dodaj wzór listy"
            onNewFile={async (v) => {
              await addListTemplate(v);
            }}
            onRemoveFile={async () => {
              await deleteListTemplate();
            }}
          />
        </FormControl>
      </Grid>
    </>
  );
};

export default ProviderFiles;
